interface CartaIconProps {
  className?: string;
  color?: string;
}

export const CartaIcon = ({ className = 'w-6 h-6', color = 'var(--ods-system-greys-white)' }: CartaIconProps) => (
  <svg viewBox="0 0 301.1 131.3" fill={color} xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M0,0v131.3h301.1V0H0z M293.1,123.3H8V8h285.1V123.3z M43.6,68.9c0-14.8,12.5-23.6,23.7-23.6c8,0,15.5,3,19.5,10l-7.5,4.4
      c-1.3-2-3.1-3.6-5.1-4.7c-2.1-1.1-4.4-1.7-6.7-1.7c-6.6,0-14.4,5.2-14.4,15.4c0,10,7.5,15.5,15,15.5c5.2,0,9.6-2.9,12.2-7.5
      l7.6,3.6c-4.3,7.8-12.1,12-21.1,12C55.5,92.3,43.6,83.6,43.6,68.9z M114.5,92.3c6.2,0,12.1-2.8,15.1-6.8v5.5h9.2V46.5h-9.2V52
      c-2.9-4-8.9-6.7-15.1-6.7c-13.6,0-23.1,10-23.1,23.5C91.4,82.1,101,92.3,114.5,92.3z M115.4,53.8c8.5,0,14.4,6.4,14.4,15
      c0,8.6-5.9,15-14.4,15c-8.7,0-14.6-6.5-14.6-15.2C100.8,60.1,106.9,53.8,115.4,53.8z M185.6,55.1h-7.1v-8.9h7.2V33h9.5v13.2h9.9
      v8.9h-9.9V91h-9.6V55.1z M231.4,92.3c6.2,0,12.1-2.8,15.1-6.8v5.5h9.2V46.5h-9.2V52c-2.9-4-8.9-6.7-15.1-6.7
      c-13.6,0-23.1,10-23.1,23.5C208.3,82.1,217.9,92.3,231.4,92.3z M232.3,53.8c8.5,0,14.4,6.4,14.4,15c0,8.6-5.9,15-14.4,15
      c-8.7,0-14.6-6.5-14.6-15.2C217.7,60.1,223.8,53.8,232.3,53.8z M158,91h-9.6V46.4h8.8v7.7c1.8-5,5.7-8.4,10.8-8.4
      c1.1,0,2.2,0.1,3.3,0.3v8.6c-7.2-0.8-13.2,4.2-13.2,15.7V91z"
    />
  </svg>
);
